/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateInvoiceEmailSettingsDataSchema = z.object({
	sendInvoiceEmails: z.boolean(),
	sendReceiptEmails: z.boolean(),
	sendInvoiceForZeroEuro: z.boolean(),
	sendInvoiceForFullyPaidByWallet: z.boolean(),
	sendReceiptForWalletPayments: z.boolean(),
	sendInvoiceForFullyPaidAtIssue: z.boolean(),
})

export type UpdateInvoiceEmailSettingsDataSchema = z.infer<typeof updateInvoiceEmailSettingsDataSchema>
